import axios from "axios";

export default {
    namespaced: true,
    state: {
        provinces: []
    },
    mutations: {
        setProvinces(state, provinces) {
            state.provinces = provinces
        }
    },
    actions: {
        setProvinces({commit}) {
            axios.get(`province`)
                .then(res => {
                    const provinces = res.data.data
                    commit('setProvinces', provinces)
                })
        },
        search({commit}, words) {
            if (words.length) {
                words = {words: words}
                let req = axios.post(`province/search`, words)

                req.then(res => {
                    const provinces = res.data.data
                    commit('setProvinces', provinces)
                })
                return req
            }
        }
    },

    getters: {
        getProvinces: state => state.provinces

    }
}
